import { render, staticRenderFns } from "./ActionDialog.vue?vue&type=template&id=572b5b45&scoped=true"
import script from "./ActionDialog.vue?vue&type=script&lang=js"
export * from "./ActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b5b45",
  null
  
)

export default component.exports